import { render, staticRenderFns } from "./common_foot.vue?vue&type=template&id=c93e5f16&scoped=true"
import script from "./common_foot.vue?vue&type=script&lang=js"
export * from "./common_foot.vue?vue&type=script&lang=js"
import style0 from "./common_foot.css?vue&type=style&index=0&id=c93e5f16&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93e5f16",
  null
  
)

export default component.exports